import { useState } from "react";
import { MailCheck, ArrowRight, Loader2 } from "lucide-react";
import Reveal from "./Reveal";

const API = process.env.REACT_APP_BACKEND_URL || "";

export const NewsletterBand = () => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | loading | ok | error
  const [message, setMessage] = useState("");

  const subscribe = async (e) => {
    e.preventDefault();
    setState("error");
    setMessage("Design preview only — newsletter subscriptions will be connected later.");
  };

  return (
    <section id="newsletter" data-testid="newsletter-band" className="bg-[var(--bg)]">
      <div className="mx-auto max-w-[1440px] px-4 sm:px-6 pt-8 pb-6 sm:pt-12 sm:pb-8">
        <Reveal>
          {/* Detached card at content width — rounded, floating between sections */}
          <div className="rounded-2xl bg-[#cf0a0a] text-white px-6 py-12 sm:px-12 sm:py-16 shadow-lg shadow-black/10 overflow-hidden relative">
            <span
              aria-hidden="true"
              className="pointer-events-none absolute -top-16 -right-16 w-64 h-64 rounded-full border-[24px] border-white/10"
            />
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center relative">
              <Reveal className="lg:col-span-6">
                <h2 className="font-display text-3xl sm:text-4xl font-semibold">
                  The Standard Daily
                </h2>
                <p className="mt-3 text-white/80 text-sm sm:text-base leading-relaxed max-w-md">
                  The day's biggest Gambian headlines — politics, business and
                  sport — delivered to your inbox every morning.
                </p>
              </Reveal>

              <Reveal delay={0.1} className="lg:col-span-6">
                {state === "ok" ? (
                  <div
                    data-testid="newsletter-success"
                    className="flex items-start gap-3 border border-white/30 bg-white/10 px-5 py-5 rounded-lg"
                  >
                    <MailCheck size={20} className="shrink-0 mt-0.5" />
                    <div>
                      <p className="font-semibold" data-testid="newsletter-success-message">
                        {message}
                      </p>
                      <button
                        onClick={() => {
                          setState("idle");
                          setEmail("");
                        }}
                        data-testid="newsletter-reset"
                        className="mt-2 text-[11px] uppercase tracking-[0.18em] font-bold text-white/70 hover:text-white transition-colors"
                      >
                        Subscribe another email
                      </button>
                    </div>
                  </div>
                ) : (
                  <form
                    onSubmit={subscribe}
                    data-testid="newsletter-form"
                    className="flex flex-col sm:flex-row gap-3"
                  >
                    <input
                      type="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="your@email.com"
                      data-testid="newsletter-email-input"
                      className="flex-1 bg-white/10 border border-white/30 rounded-md px-4 py-3.5 text-white placeholder-white/50 outline-none focus:border-white focus:bg-white/15 transition-colors"
                    />
                    <button
                      type="submit"
                      disabled={state === "loading"}
                      data-testid="newsletter-submit-button"
                      className="inline-flex items-center justify-center gap-2 bg-[#141414] text-white px-6 py-3.5 text-[12px] font-bold uppercase tracking-[0.18em] hover:bg-black disabled:opacity-60 transition-colors rounded-md"
                    >
                      {state === "loading" ? (
                        <>
                          <Loader2 size={14} className="animate-spin" /> Subscribing…
                        </>
                      ) : (
                        <>
                          Subscribe <ArrowRight size={14} />
                        </>
                      )}
                    </button>
                  </form>
                )}

                {state === "error" && (
                  <p
                    data-testid="newsletter-error-message"
                    className="mt-3 text-[12px] font-semibold text-white bg-[#8f0a20] border border-white/25 px-3 py-2 inline-block rounded-md"
                  >
                    {message}
                  </p>
                )}
                <p className="mt-3 text-[11px] text-white/60" data-testid="newsletter-fineprint">
                  Free of charge. Unsubscribe anytime.
                </p>
              </Reveal>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default NewsletterBand;
